import React from 'react';
import dayjs from '../helpers/dates';
import {
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Theme } from '../theme';
import { currencyFormatter, parseDateValue } from '../helpers/utils';

interface ChartDataPoint {
  deadline: string;
  status: string;
  amount_awarded?: string | number;
  amount_requested?: string | number;
}

interface YearObj {
  [year: number]: {
    name: number;
    Awarded: number;
    Pending: number;
    Declined: number;
    amt: number;
  };
}

const calcData = (data: ChartDataPoint[], obj: YearObj) => {
  data.forEach((project) => {
    const projectYear = parseDateValue(project.deadline).year();
    if (obj[projectYear]) {
      if (project.status === 'Awarded') {
        obj[projectYear].Awarded +=
          parseInt(String(project.amount_awarded), 10) || 0;
      }
      if (project.status === 'Pending') {
        obj[projectYear].Pending +=
          parseInt(String(project.amount_requested), 10) || 0;
      }
      if (project.status === 'Declined') {
        obj[projectYear].Declined +=
          parseInt(String(project.amount_requested), 10) || 0;
      }
    }
  });
  return Object.keys(obj).map((key) => ({
    ...obj[key],
    amt: obj[key].Awarded + obj[key].Pending + obj[key].Declined,
  }));
};

const generateKeyVals = (name: number) => ({
  name,
  Awarded: 0,
  Pending: 0,
  Declined: 0,
  amt: 0,
});

interface ChartProps {
  data: ChartDataPoint[];
}

const Chart = ({ data }: ChartProps) => {
  const twoYearsAgo = dayjs().subtract(2, 'year').year();
  const lastYear = dayjs().subtract(1, 'year').year();
  const thisYear = dayjs().year();
  const dataObj = {
    [twoYearsAgo]: generateKeyVals(twoYearsAgo),
    [lastYear]: generateKeyVals(lastYear),
    [thisYear]: generateKeyVals(thisYear),
  };
  return (
    <ResponsiveContainer id="ytd-chart">
      <BarChart
        data={calcData(data, dataObj)}
        margin={{
          top: 10,
          right: 10,
          left: 10,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <Tooltip formatter={(value: any) => currencyFormatter.format(value)} />
        <Legend />
        <Bar dataKey="Awarded" fill={`${Theme.colors.secondaryLight}`} />
        <Bar dataKey="Pending" fill={`${Theme.colors.yellowgreen}`} />
        <Bar dataKey="Declined" fill={`${Theme.colors.danger}`} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default Chart;
